export default __webpack_public_path__ + "static/media/approved.a1b39708.svg";